import { GET_ALL_TESTIMONIALS, GET_TESTIMONIALS_DETAILS } from "./actions";

const initialState = {
  testimonialsList: {
    docs: [],
    totalDocs: 0,
    limit: 10,
    page: 1,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
  testimonialData: {},
  loading: true,
};

const testimonialReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_ALL_TESTIMONIALS:
      return {
        ...state,
        loading: false,
        testimonialsList: payload,
      };
    case GET_TESTIMONIALS_DETAILS:
      return {
        ...state,
        loading: false,
        testimonialData: payload,
      };

    default:
      return state;
  }
};

export default testimonialReducer;
